<template>
  <div>
    <section v-if="detail != '' && !showIsDimission" class="container">
      <!-- info -->
      <div class="info">
        <h2>{{ detail.name }}</h2>
        <ul class="keyInfo">
          <li>
            <p>{{ detail.phone }}</p>
          </li>
          <li>
            <p>&nbsp;&nbsp;|&nbsp;&nbsp;</p>
            <p v-show="detail.work_type == 1">长期工</p>
            <p v-show="detail.work_type == 2">临时工</p>
            <p>&nbsp;&nbsp;|&nbsp;&nbsp;</p>
          </li>
          <li>
            <p v-show="detail.status == 9">待认证</p>
            <p v-show="detail.status == 10">待签约</p>
            <p v-show="detail.status == 11">新合同待签</p>
            <p v-show="detail.status == 20">资料待审核</p>
            <p v-show="detail.status == 31">资料审核驳回</p>
            <p v-show="detail.status == 40">已入职</p>
            <p v-show="detail.status == 50">离职合同待签</p>
            <p v-show="detail.status == 51">已离职</p>
          </li>
        </ul>
        <div class="operationKinsfolk">
          <a-button
            v-show="detail.is_leave != 1"
            @click="dimissionPage"
            style="background: #F56C6C; color: #fff"
            >离职</a-button
          >
        </div>
        <ul class="financeInfo">
          <li class="disBlock">
            <label>项目名称：</label>
            <p>{{ detail.project_name }}</p>
          </li>
          <li v-show="detail.shop_info != ''">
            <label>入职门店/区域/大仓：</label>
            <p>{{ detail.shop_info.name }}</p>
          </li>
          <li v-show="detail.shop_info != ''">
            <label>地址：</label>
            <p>
              {{
                detail.shop_info.province +
                  detail.shop_info.city +
                  detail.shop_info.area +
                  detail.shop_info.address
              }}
            </p>
          </li>
          <li>
            <label>入职岗位：</label>
            <p>{{ detail.guard_role_names }}</p>
          </li>
          <li>
            <label>简历来源：</label>
            <p>{{ detail.resume_source_name }}</p>
          </li>
          <li>
            <label>来源类型：</label>
            <p>{{ detail.resume_source_info.type }}</p>
          </li>
          <li>
            <label>来源渠道：</label>
            <p>{{ detail.resume_source_info.channel }}</p>
          </li>
          <li v-show="detail.resume_source_info.details != ''">
            <label>来源账号：</label>
            <p>{{ detail.resume_source_info.details }}</p>
          </li>
          <br />
          <li>
            <label>入职日期：</label>
            <p>{{ detail.entry_time.substring(0, 10) }}</p>
          </li>
          <li>
            <label>入职操作时间：</label>
            <p>{{ detail.create_time }}</p>
          </li>
          <li>
            <label>入职操作人员：</label>
            <p>{{ detail.entry_user_name }}</p>
          </li>
          <li v-show="detail.entry_remark != ''">
            <label>入职备注：</label>
            <p>{{ detail.entry_remark }}</p>
          </li>
          <li v-show="detail.status == 51 || detail.status == 50">
            <label>离职日期：</label>
            <p>{{ detail.leave_time.substring(0, 10) }}</p>
          </li>
          <li v-show="detail.status == 51 || detail.status == 50">
            <label>离职操作时间：</label>
            <p>{{ detail.leave_create_time }}</p>
          </li>
          <li v-show="detail.status == 51 || detail.status == 50">
            <label>离职操作人员：</label>
            <p>{{ detail.leave_user_name }}</p>
          </li>
          <li v-show="detail.status == 51 || detail.status == 50">
            <label>离职原因：</label>
            <p>{{ detail.reason }}</p>
          </li>
          <li v-show="detail.status == 51 || detail.status == 50">
            <label>离职是否结算：</label>
            <p v-show="detail.is_settlement == 1">不结算</p>
            <p v-show="detail.is_settlement == 2">结算</p>
          </li>
        </ul>
      </div>
      <!-- info end -->
      <!-- 修改入离职日期 -->
      <div class="operationLog" v-show="detail.entry_leave_log != ''">
        <h4>修改入离职日期记录</h4>
        <a-timeline>
          <a-timeline-item
            v-for="(item, index) in detail.entry_leave_log"
            :key="index"
            :color="item.type == 2 ? 'red' : 'green'"
          >
            <ul class="operationLog-list">
              <li>
                <label>类型：</label>
                <p v-show="item.type == 1">入职日期</p>
                <p v-show="item.type == 2">离职日期</p>
              </li>
              <li>
                <label>修改前日期：</label>
                <p>{{ item.before_time.substring(0, 10) }}</p>
              </li>
              <li>
                <label>备注：</label>
                <p>{{ item.remark }}</p>
              </li>
              <li>
                <label>操作时间：</label>
                <p>{{ item.create_time }}</p>
              </li>
              <li>
                <label>操作人员：</label>
                <p>{{ item.operation_user_name }}</p>
              </li>
            </ul>
          </a-timeline-item>
        </a-timeline>
      </div>
      <!-- 修改入离职日期 end -->
    </section>
    <!-- 离职 -->
    <dimission
      v-show="showIsDimission"
      :dimissionDetail="dimissionDetail"
      v-on:hideInDimission="hideInDimission"
    />
    <!-- 离职 end -->
  </div>
</template>
<script>
import axios from "axios";
import dimission from "@/components/worker/dimission.vue"; //离职
export default {
  data() {
    return {
      detail: "",
      showIsKinsfolk: false,
      kinsfolk: {
        relationship: "",
        name: "",
        phone: "",
        idcard: "",
        bank_card_number: ""
      },
      idcard_img_front: [],
      idcard_img_back: [],
      showIsDimission: false,
      dimissionDetail: ""
    };
  },
  props: {
    entry_id: {}
  },
  watch: {
    entry_id() {
      this.showIsDimission = false;
      this.getDetail();
    }
  },
  mounted() {
    if (this.entry_id != undefined && this.entry_id != "") {
      this.showIsDimission = false;
      this.getDetail();
    }
  },
  components: {
    dimission
  },
  methods: {
    getDetail() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "resume_admin/queryAllEntryLeaveRecordDetails";
      axios
        .post(url, {
          entry_id: this.entry_id,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.detail = res.data.data;
            this.idcard_img_front = [];
            this.idcard_img_back = [];
            if (this.detail.idcard_img_front != "") {
              this.idcard_img_front.push(this.detail.idcard_img_front);
            }
            if (this.detail.idcard_img_back) {
              this.idcard_img_back.push(this.detail.idcard_img_back);
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    dimissionPage() {
      this.showIsDimission = true;
      this.dimissionDetail = this.detail;
    },
    hideInDimission(msg) {
      this.showIsDimission = false;
      if (msg) {
        this.getDetail();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  padding: 30px 4%;
  h3 {
    font-size: 16px;
    margin-bottom: 20px;
  }
  .proStyle {
    margin-top: 20px;
    table {
      min-width: 30%;
      margin-bottom: 30px;
      td,
      th {
        border: 1px solid #ccc;
        font-size: 14px;
        line-height: 20px;
        padding: 4px 10px;
      }
      a {
        display: block;
        font-size: 14px;
        line-height: 20px;
      }
      th {
        background: #ededed;
      }
    }
  }
  .info {
    position: relative;
    .keyInfo {
      margin-bottom: 20px;
      li {
        display: inline-block;
        p {
          display: inline-block;
        }
      }
    }
    .financeInfo {
      li {
        display: inline-block;
        width: 33.3%;
        margin-bottom: 20px;
        p,
        label {
          display: inline-block;
          vertical-align: top;
          font-size: 14px;
          line-height: 20px;
        }
        .imgStyle {
          display: inline-block;
          vertical-align: top;
          img {
            height: 80px;
            width: 80px;
            object-fit: cover;
          }
        }
      }
      .disBlock {
        display: block;
      }
    }
  }
  .steps {
    width: 100%;
  }
  .description {
    width: 100%;
    > li {
      display: inline-block;
      min-width: 33.3%;
      p,
      label {
        display: inline-block;
      }
    }
  }
  .dialogsBox > div {
    margin-top: 100px;
  }
  .operationKinsfolk {
    position: absolute;
    right: 20px;
    top: 10px;
  }
  .operationLog {
    h4 {
      font-size: 14px;
      margin-bottom: 12px;
    }
    .operationLog-list {
      > li {
        display: inline-block;
        min-width: 30%;
        margin-right: 20px;
        margin-bottom: 10px;
        p,
        label {
          display: inline-block;
          font-size: 14px;
          line-height: 20px;
          vertical-align: top;
        }
        p {
          max-width: 80%;
        }
      }
    }
  }
}
.dialogsBox {
  > div {
    margin-top: 100px;
  }
}
.info {
  h2 {
    margin-bottom: 20px;
  }
}
</style>
